import { datalyzeProblemApis } from "../store/services/datalyzeProblems";
import {
    clearAllCompletedChartsForProblem,
    clearCleanedDataset,
} from "../store/slices";

/** Maps API outcome / assessmentOutcome to pass | fail | null (for cards, badges). */
export function derivePassFail(outcome, assessmentOutcome) {
    const o = String(outcome || "").toLowerCase();
    if (o === "fail") return "fail";
    if (o === "pass") return "pass";
    const a = String(assessmentOutcome || "").toLowerCase();
    if (a.includes("fail")) return "fail";
    if (a.includes("pass")) return "pass";
    return null;
}

/** Location state key: gamelist / usecase shows fetch-user loader until cleared. */
export const REFRESH_USER_RECORDS_KEY = "refreshUserAfterRetry";

/** @deprecated Use REFRESH_USER_RECORDS_KEY */
export const REFRESH_USER_AFTER_RETRY_KEY = REFRESH_USER_RECORDS_KEY;

export function buildRefreshUserRecordsNavigationState() {
    return { [REFRESH_USER_RECORDS_KEY]: true };
}

/** Invalidate cached user + problem lists and force a fresh fetch-user. */
export async function refreshUserRecordsAfterAssessment({
    dispatch,
    userAuthApis,
    datalyzeProblemApis,
    problemId,
    refetchUserDetails,
    refetchAllProblems,
}) {
    dispatch(userAuthApis.util.invalidateTags(["UserDetails"]));
    const tags = ["Problems", "Leaderboard"];
    if (problemId) {
        tags.push({ type: "Problem", id: String(problemId) });
    }
    dispatch(datalyzeProblemApis.util.invalidateTags(tags));

    try {
        await dispatch(
            userAuthApis.endpoints.getUserDetails.initiate(undefined, {
                forceRefetch: true,
            })
        ).unwrap();
    } catch (_e) {
        if (refetchUserDetails) {
            try {
                await refetchUserDetails().unwrap();
            } catch (_e2) {
                // ignore
            }
        }
    }

    if (refetchAllProblems) {
        try {
            await refetchAllProblems({ location: "app" }).unwrap();
        } catch (_e) {
            // ignore
        }
    }
}

/** POST assessment-outcome + clear in-memory gameplay caches + refetch lists. */
export async function executeAssessmentRetry({
    dispatch,
    postAssessmentOutcome,
    problemId,
    refetchUserDetails,
    refetchAllProblems,
    skipUserRefetch = false,
}) {
    const id = String(problemId);
    await postAssessmentOutcome({
        body: {
            problemId: id,
            eligible: false,
        },
    }).unwrap();
    dispatch(clearCleanedDataset({ useCaseId: id }));
    dispatch(clearAllCompletedChartsForProblem({ problemId: id }));
    dispatch(
        datalyzeProblemApis.util.invalidateTags([
            "Problems",
            "Domains",
            "Leaderboard",
            { type: "Problem", id },
        ])
    );
    if (!skipUserRefetch && refetchUserDetails) {
        try {
            await refetchUserDetails().unwrap();
        } catch (_e) {
            // ignore
        }
    }
    try {
        await refetchAllProblems({ location: "app" }).unwrap();
    } catch (_e) {
        // ignore
    }
}
